import { graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ContentfulImageQuery, Img, WmkImage } from "wmk-image";
import { useState, useEffect } from "react";
import { Parallax } from "react-scroll-parallax";

const SiteMockup = ({ url, title }: { url: string; title: string }) => {
  const [winWidth, setWinWidth] = useState(1200);
  const data: { mobile: ContentfulImageQuery; desktop: ContentfulImageQuery } =
    useStaticQuery(query);

  useEffect(() => {
    const resize = () => {
      if (window) {
        setWinWidth(window.innerWidth);
      }
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  });
  const isDesktop = winWidth > 740;
  return url ? (
    <Container fluid>
      <Row style={{ position: "relative", maxWidth: 1200, margin: "auto" }}>
        <Col style={{ display: "flex", justifyContent: "center" }}>
          {isDesktop ? (
            <WmkImage image={new Img(data.desktop)} />
          ) : (
            <WmkImage image={new Img(data.mobile)} />
          )}
        </Col>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: isDesktop ? `68%` : `82%`,
            width: isDesktop ? `92%` : `66%`,
            margin: isDesktop ? "0 4% 32% 4%" : "12.5% 17% 9.5% 17%",
            zIndex: 10,
            overflow: `hidden`,
          }}
        >
          <iframe
            src={url}
            title={title}
            style={{
              position: `absolute`,
              top: isDesktop ? `5%` : 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        </div>
      </Row>
    </Container>
  ) : null;
};

export default SiteMockup;

const query = graphql`
  {
    desktop: contentfulAsset(title: { eq: "Mac Monitor Frame" }) {
      ...NodeImageFields
      gatsbyImageData
    }
    mobile: contentfulAsset(title: { eq: "smartphone frame" }) {
      ...NodeImageFields
      gatsbyImageData
    }
  }
`;
